export class OPAuth0User {
  userId: string = null;
  username: string = null;
  email: string = null;
  emailVerified: boolean = null;
  createdAt: Date = null;
  updatedAt: Date = null;
  lastLogin: Date = null;
  blocked: boolean = null;

  constructor(data: Partial<OPAuth0User> = null) {
    if (data) {
      this.userId = data.userId ?? null;
      this.username = data.username ?? null;
      this.email = data.email ?? null;
      this.emailVerified = data.emailVerified ?? null;
      this.createdAt = data.createdAt ? new Date(data.createdAt) : null;
      this.updatedAt = data.updatedAt ? new Date(data.updatedAt) : null;
      this.lastLogin = data.lastLogin ? new Date(data.lastLogin) : null;
      this.blocked = data.blocked ?? null;
    }
  }
}
